import { render, staticRenderFns } from "./nxMobileInput.vue?vue&type=template&id=b93faca4&scoped=true&"
import script from "./nxMobileInput.vue?vue&type=script&lang=js&"
export * from "./nxMobileInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93faca4",
  null
  
)

export default component.exports